export const locales = ['et', 'en'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'et';

export const languageNames: Record<Locale, string> = {
  et: 'Eesti',
  en: 'English',
};

const dictionaries = {
  et: {
    meta: { title: 'mish?', description: 'Sinu link maailma veebi!' },
    nav: { home: 'Avaleht', about: 'Meist', projects: 'Projektid', contact: 'Kontakt' },
    projects: {
      title: 'Projektid',
      items: [
        {
          name: 'Atlandi Sõudjad',
          status: 'Valminud',
          tags: [],
          description:
            'atlandisõudjad.ee oli veebileht, mis oli pühendatud eestlastest koosnevale neljaliikmelisele tiimile, kes sõudsid 2025. aasta detsembris sõudepaadiga üle Atlandi ookeani. Ettevõtmine täitis ka heategevuslikku eesmärki — projektist ülejäänud kogutud raha annetati kahe Eestis tegutseva heategevusliku organisatsiooni toetuseks. Lõime huvitava ja informatiivse veebilehe, mis tutvustas sõudjate meeskonda, ettevalmistust ja väljakutseid ning võimaldas külastajatel projekti toetada. Veebileht pälvis ka Kuldmuna disainiauhinna nominatsiooni.',
          link: {
            label: 'Kuldmuna nominatsioon',
            url: 'https://kuldmuna.ee/arhiiv/index.php/work/nominee/rowtalia-atlandi-soudjad-10033?lang=en',
          },
        },
        {
          name: 'Boardmembers',
          status: 'Tulemas',
          tags: ['iOS'],
          description:
            'Boardmembers on peagi ilmuv rakendus fotokollaažide loomiseks, kas üksi või koos teistega jagatud laudadel. Kasutajad saavad lahtritesse paigutada fotosid pildistades või lisades ning valminud kollaaže eksportida.',
          link: undefined as { label: string; url: string } | undefined,
        },
      ],
    },
    about: {
      title: 'Meist',
      body: [
        'mish [mɪʃ] on Eesti disaini- ja arendusstuudio, mis on alates 2019. aastast tegelenud graafilise disaini ja veebiarendusega. Meie jaoks on oluline selge disain ning hoolikas teostus.',
        'Oleme väike ja tihedalt seotud meeskond, mis tähendab, et vastutame iga projekti eest ise algusest lõpuni: disainist ja arendusest kuni käivitamise ja hooldamiseni.',
      ],
    },
    contact: {
      title: 'Kontakt',
      description: 'Küsimusi? Kirjuta meile ja räägime lähemalt.',
      email: 'mish@mish.ee',
      company: 'mish OÜ',
      registryLabel: 'Registrikood',
      registryCode: '14723162',
    },
    privacy: {
      title: 'Privaatsus­poliitika',
      updated: 'Kehtib alates 27.09.2026',
      sections: [
        {
          heading: 'Üldsätted',
          body: [
            'Käesolev privaatsuspoliitika selgitab, kuidas mish OÜ (registrikood 14723162, e-post mish@mish.ee) vastutava töötlejana töötleb isikuandmeid seoses veebilehe mish.ee ja iOS-rakendusega Boardmembers.',
          ],
        },
        {
          heading: 'Andmed, mida töötleme veebilehel mish.ee',
          body: [
            'Kui võtad meiega ühendust e-posti teel, töötleme sinu poolt jagatud andmeid (näiteks nimi, e-posti aadress ja sõnumi sisu) üksnes selleks, et sinu päringule vastata.',
            'Meie veebimajutuse pakkuja kogub automaatselt tehnilisi logiandmeid (näiteks IP-aadress, brauseri tüüp ja ligipääsu aeg) veebilehe turvalisuse ja toimimise tagamiseks.',
          ],
        },
        {
          heading: 'Küpsised',
          body: [
            'Kasutame üht hädavajalikku küpsist, et jätta meelde sinu eelistatud kuvarežiim (hele/tume). See küpsis ei sisalda isikuandmeid ega jälgi sind teistel veebilehtedel. Me ei kasuta analüütika- ega turundusküpsiseid.',
          ],
        },
        {
          heading: 'Andmed, mida töötleme rakenduses Boardmembers',
          body: [
            'Boardmembers salvestab sinu lauad, fotod ja märkmed sinu enda Apple iCloud kontos, kasutades Apple’i CloudKit-raamistikku. Meil endil ei ole selleks servereid ega andmebaasi — sinu sisu säilitab ja sünkroniseerib Apple, vastavalt Apple’i enda privaatsuspoliitikale (apple.com/legal/privacy).',
            'Rakendus palub sul valida kuvatava nime ning genereerib sinu seadmes juhusliku, mitteidentifitseeriva liikme ID. Kui liitud kellegi teise jagatud lauaga, muutub sinu kuvatav nimi nähtavaks selle laua teistele osalistele.',
            'Laua täitmiseks küsib rakendus ligipääsu kaamerale ning eksporditud pildi salvestamisel õigust lisada fotosid sinu fotogaleriisse. Rakendus ei küsi ligipääsu sinu olemasolevale fotogaleriile, kontaktidele, asukohale ega mikrofonile.',
          ],
        },
        {
          heading: 'Laudade jagamine ja eksportimine',
          body: [
            'Saad kutsuda teisi inimesi oma lauale, kasutades Apple’i enda iCloud jagamisfunktsiooni. See jagab laua fotosid, märkmeid ja kuvatavaid nimesid otse iCloud kontode vahel — mish ei näe ega salvesta seda infot oma süsteemides.',
            'Saad laua eksportida oma seadmesse (näiteks foto või PDF-ina). Eksport toimub täielikult sinu seadmes Apple’i jagamismenüü kaudu; me ei saa sellest koopiat, välja arvatud juhul, kui otsustad selle meile ise (näiteks e-kirjaga) saata.',
          ],
        },
        {
          heading: 'Push-teavitused',
          body: [
            'Rakendus kasutab Apple’i CloudKit push-teavitusi, et hoida lauad sinu seadmete vahel sünkroonis. Tegemist on hääletute taustateavitustega — me ei saada turundusteavitusi ning teavituste sisu ei liigu mish’i enda süsteemide kaudu.',
          ],
        },
        {
          heading: 'Ostud ja tellimused',
          body: [
            'Boardmembers võib pakkuda valikulisi ostusiseseid oste ja tellimusi (näiteks "Executive" plaan), mida müüakse ja töödeldakse täielikult Apple App Store’i ja StoreKiti kaudu. mish ei saa ega salvesta sinu maksekaardi andmeid — neid haldab Apple vastavalt oma privaatsuspoliitikale.',
            'Apple annab meile piiratud tehinguinfo (näiteks kas tellimus on aktiivne), et rakendus saaks vastavad funktsioonid avada. Tellimused uuenevad automaatselt, kui neid ei tühistata vähemalt 24 tundi enne kehtiva perioodi lõppu, ning neid saab igal ajal hallata või tühistada oma Apple ID konto seadetes.',
          ],
        },
        {
          heading: 'Tugipäringud',
          body: [
            'Kui kasutad rakenduse valikut "Saada tagasisidet", avaneb eeltäidetud e-kiri aadressile mish@mish.ee, mis võib sisaldada põhilist diagnostikainfot (rakenduse versioon, seadme mudel ja nimi, opsüsteemi versioon, tellimuse plaan ja keel). See saadetakse ainult siis, kui otsustad selle e-kirja ise ära saata.',
          ],
        },
        {
          heading: 'Õiguslik alus ja säilitamine',
          body: [
            'Andmeid töötleme meie õigustatud huvi alusel (veebilehe ja rakenduse pakkumine ning turvalisus), lepingu täitmiseks (ostusisesed ostud ja tellimused) ning sinu päringutele vastamiseks. Laua- ja fotoandmeid säilitatakse seni, kuni hoiad neid rakenduses — laua või foto kustutamine, või iCloud-andmete kustutamine, eemaldab need. Kirjavahetust säilitame nii kaua, kui see on vajalik päringu lahendamiseks või seadusest tulenevate kohustuste täitmiseks.',
          ],
        },
        {
          heading: 'Laste privaatsus',
          body: [
            'mish.ee ja Boardmembers ei ole suunatud alla 13-aastastele lastele ning me ei kogu teadlikult isikuandmeid selle vanuserühma lastelt. Kui arvad, et laps on meile isikuandmeid edastanud, võta meiega ühendust ja me kustutame need.',
          ],
        },
        {
          heading: 'Rahvusvaheline kasutamine',
          body: [
            'Boardmembers ja mish.ee on kättesaadavad kogu maailmas, sealhulgas kasutajatele Ameerika Ühendriikides. Sinu rakenduse andmete talletamine ja töötlemine toimub Apple’i globaalse iCloud-taristu kaudu, vastavalt Apple’i enda privaatsuspoliitikale. Me ei müü isikuandmeid ning Californias elavad kasutajad võivad meiega ühendust võtta aadressil mish@mish.ee, et küsida, milliseid isikuandmeid me nende kohta hoiame.',
          ],
        },
        {
          heading: 'Sinu õigused',
          body: [
            'Isikuandmete kaitse üldmääruse (GDPR) alusel on sul õigus tutvuda enda andmetega, nõuda nende parandamist või kustutamist, piirata töötlemist, esitada vastuväiteid ning taotleda andmete ülekandmist. Nende õiguste kasutamiseks võta meiega ühendust aadressil mish@mish.ee.',
            'Kuna sinu laudu, fotosid ja märkmeid hoitakse sinu enda iCloud kontos, saad need ise ja kohe kustutada: Seaded → [sinu nimi] → iCloud → Halda konto salvestusruumi → Boardmembers → Kustuta andmed, või kustutades rakenduse. Meil endil ei ole sellest sisust eraldi koopiat. Kui kirjutad meile ja palud oma andmed kustutada, kustutame kirjavahetuse ning suuname sulle vajadusel eelnimetatud iseteeninduse juhised.',
            'Kui leiad, et oleme sinu andmeid töödelnud õigusvastaselt, on sul õigus pöörduda Andmekaitse Inspektsiooni poole (aki.ee).',
          ],
        },
        {
          heading: 'Muudatused poliitikas',
          body: [
            'Võime seda poliitikat aeg-ajalt uuendada, et kajastada muudatusi veebilehel mish.ee, rakenduses Boardmembers või kohaldatavas õiguses. Ülal toodud kuupäev näitab, millal seda viimati uuendati.',
          ],
        },
      ],
    },
    notFound: { title: '404', body: 'Seda lehte ei leitud.' },
    game: {
      intro: 'Disaini- ja veebistuudio.',
      tapToPlay: 'Kliki ja mängi',
      gameOver: 'Mäng läbi — puuduta, et proovida uuesti',
    },
  },
  en: {
    meta: { title: 'mish?', description: 'Your link to the world wide web!' },
    nav: { home: 'Home', about: 'About us', projects: 'Projects', contact: 'Contact us' },
    projects: {
      title: 'Projects',
      items: [
        {
          name: 'Atlandi Sõudjad',
          status: 'Live',
          tags: [],
          description:
            "atlandisõudjad.ee was a website for a four-person Estonian team who rowed across the Atlantic Ocean in December 2025. The project also carried a charitable purpose — funds raised beyond the expedition's costs were donated to two Estonian charities. We built an engaging, informative website that introduced the team, their preparation, and the challenges they faced, and let visitors support the project. The site was also nominated for Kuldmuna, Estonia's national design award.",
          link: {
            label: 'Kuldmuna nomination',
            url: 'https://kuldmuna.ee/arhiiv/index.php/work/nominee/rowtalia-atlandi-soudjad-10033?lang=en',
          },
        },
        {
          name: 'Boardmembers',
          status: 'Upcoming',
          tags: ['iOS'],
          description:
            'Boardmembers is an upcoming app for creating photo collages, alone or on shared boards with others. Users can fill cells by taking or adding photos, then export the finished collage.',
          link: undefined as { label: string; url: string } | undefined,
        },
      ],
    },
    about: {
      title: 'About us',
      body: [
        'mish [mɪʃ] is an Estonian design and development studio, doing graphic design and web development since 2019. We care about clear design and careful craftsmanship.',
        "We're a small, closely-knit team, which means we take full ownership of every project — from design and development through launch and ongoing support.",
      ],
    },
    contact: {
      title: 'Contact us',
      description: "Questions? Send us a message and let's talk about it.",
      email: 'mish@mish.ee',
      company: 'mish OÜ',
      registryLabel: 'Registry code',
      registryCode: '14723162',
    },
    privacy: {
      title: 'Privacy Policy',
      updated: 'Effective as of 27 Sept 2026',
      sections: [
        {
          heading: 'General provisions',
          body: [
            'This privacy policy explains how mish OÜ (registry code 14723162, email mish@mish.ee), as data controller, processes personal data in connection with the website mish.ee and the iOS app Boardmembers.',
          ],
        },
        {
          heading: 'Data we process on mish.ee',
          body: [
            'If you contact us by email, we process the data you share (such as your name, email address, and message content) solely to respond to your inquiry.',
            'Our hosting provider automatically collects technical log data (such as IP address, browser type, and access time) to keep the site secure and operational.',
          ],
        },
        {
          heading: 'Cookies',
          body: [
            'We use one strictly necessary cookie to remember your preferred display mode (light/dark). This cookie contains no personal data and does not track you across other websites. We do not use analytics or marketing cookies.',
          ],
        },
        {
          heading: 'Data we process in the Boardmembers app',
          body: [
            "Boardmembers stores your boards, photos, and notes in your own Apple iCloud account via Apple's CloudKit framework. We do not operate our own servers or database — your content is stored and synced by Apple, under Apple's own privacy policy (apple.com/legal/privacy).",
            "The app asks you to choose a display name and generates a random, non-identifying member ID on your device. If you join a board shared by someone else, your display name becomes visible to the other participants of that board.",
            'To fill a board, the app requests access to your camera and, when saving an exported image, permission to add photos to your photo library. It does not request access to your existing photo library, contacts, location, or microphone.',
          ],
        },
        {
          heading: 'Sharing and exporting boards',
          body: [
            "You can invite other people to a board using Apple's native iCloud sharing. This shares board photos, notes, and display names directly between iCloud accounts — mish never sees or stores this data on its own systems.",
            "You can export a board to your device (for example as a photo or PDF). Exporting happens entirely on your device via Apple's share sheet; we do not receive a copy unless you choose to send it to us yourself, for example by email.",
          ],
        },
        {
          heading: 'Push notifications',
          body: [
            "The app uses Apple's CloudKit push notifications to keep boards in sync between your devices. These are silent background updates — we do not send marketing notifications, and no notification content passes through mish's own systems.",
          ],
        },
        {
          heading: 'Purchases and subscriptions',
          body: [
            "Boardmembers may offer optional in-app purchases and subscriptions (such as an 'Executive' plan), sold and processed entirely through Apple's App Store and StoreKit. mish does not receive or store your payment card details — these are handled by Apple under Apple's own privacy policy.",
            'Apple provides us with limited transaction information (such as whether a subscription is active) so the app can unlock the relevant features. Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current period, and can be managed or cancelled at any time in your Apple ID account settings.',
          ],
        },
        {
          heading: 'Support requests',
          body: [
            "If you use the app's 'Send Feedback' option, it opens a pre-filled email to mish@mish.ee that may include basic diagnostic information (app version, device model and name, OS version, subscription plan, and language). This is sent only when you choose to send that email yourself.",
          ],
        },
        {
          heading: 'Legal basis and retention',
          body: [
            'We process data based on our legitimate interest (providing and securing the website and app), performance of a contract (in-app purchases and subscriptions), and to respond to your inquiries. Board and photo data is retained for as long as you keep it in the app — deleting a board or photo, or deleting your iCloud data, removes it. Correspondence is kept only as long as needed to resolve the inquiry or meet legal obligations.',
          ],
        },
        {
          heading: "Children's privacy",
          body: [
            'mish.ee and Boardmembers are not directed at children under 13, and we do not knowingly collect personal data from children under that age. If you believe a child has provided us with personal data, contact us and we will delete it.',
          ],
        },
        {
          heading: 'International use',
          body: [
            "Boardmembers and mish.ee are available worldwide, including to users in the United States. Storage and processing of your app data happens through Apple's global iCloud infrastructure under Apple's own privacy policy. We do not sell personal data, and California residents may contact us at mish@mish.ee to ask what personal data, if any, we hold about them.",
          ],
        },
        {
          heading: 'Your rights',
          body: [
            'Under the General Data Protection Regulation (GDPR), you have the right to access, correct, or delete your data, restrict or object to processing, and request data portability. To exercise these rights, contact us at mish@mish.ee.',
            "Because your boards, photos, and notes are held in your own iCloud account, you can delete them yourself immediately: Settings → [your name] → iCloud → Manage Account Storage → Boardmembers → Delete Data, or by deleting the app. We hold no separate copy of this content. If you email us asking for your data to be deleted, we will delete that correspondence and point you to the self-service steps above where relevant.",
            'If you believe we have processed your data unlawfully, you have the right to lodge a complaint with the Estonian Data Protection Inspectorate (aki.ee).',
          ],
        },
        {
          heading: 'Changes to this policy',
          body: [
            "We may update this policy from time to time to reflect changes to mish.ee, the Boardmembers app, or applicable law. The 'effective as of' date above shows when it was last updated.",
          ],
        },
      ],
    },
    notFound: { title: '404', body: 'This page could not be found.' },
    game: {
      intro: 'A design and a web studio.',
      tapToPlay: 'Tap to play',
      gameOver: 'Game over — tap to try again',
    },
  },
} as const;

export function getDictionary(locale: Locale) {
  return dictionaries[locale];
}

export type Dictionary = ReturnType<typeof getDictionary>;

export function localePath(locale: Locale, path: string) {
  return locale === defaultLocale ? path : `/${locale}${path}`;
}
